<template>
  <div v-loading="isLoading">
    <el-table
      :data="teams"
      size="mini"
      stripe
    >
      <el-table-column
        label="Name"
        prop="name"
      />

      <el-table-column
        label="Code"
        prop="code"
      />

      <el-table-column
        label="Description"
        prop="description"
      />

      <el-table-column
        label="Actions"
        align="right"
      >
        <template slot-scope="scope">
          <el-dropdown
            split-button
            size="mini"
            type="primary"
            class="mr-2"
            trigger="click"
            @click="handleImpersonationOpen360(scope.row)"
          >
            Impersonate
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="handleImpersonation(scope.row)">
                Impersonate OpenFreight
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="text-center pt-3"
      :current-page.sync="teams.page"
      :page-size.sync="teams.limit"
      layout="total, prev, pager, next, jumper"
      :total="teams.total"
      @size-change="reload"
      @current-change="reload"
    />
  </div>
</template>

<script>
export default {
  components: {
    //
  },
  props: {
    account: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      teams: []
    }
  },
  async mounted () {
    this.isLoading = true

    this.teams = await this.$sdk.account_team.list(request => {
      request.context = this.account
      request.limit = 3
    })

    this.isLoading = false
  },
  methods: {
    async reload () {
      this.isLoading = true

      await this.teams.reload()

      this.isLoading = false
    },
    async handleImpersonationOpen360 (team) {
      // Request an impersonation token for the team, which will be used by Open360 to authenticate the user
      await this.$sdk.account_team.impersonate(
        team.account.slug,
        (await this.$session.instance).tenancy.id,
        () => {
          this.$message.success('Impersonation Token Generated. Redirecting to Open360...')
        }
      )
    },
    async handleImpersonation (team) {
      window
        .open(
          this
            .$router
            .resolve({
              name: 'legacy-handover',
              query: {
                tenancy: (await this.$session.instance).tenancy.id,
                token: await this.$session.token,
                'impersonation-token': team.legacy.hash
              }
            })
            .href,
          '_blank'
        )
    }
  }
}
</script>
